import { render, staticRenderFns } from "./DropdownItemContainer.vue?vue&type=template&id=170d3f6b&"
import script from "./DropdownItemContainer.vue?vue&type=script&lang=js&"
export * from "./DropdownItemContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports